
import React, { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomText, { textStyles } from "../../components/CustomText";
import CustomButton from "../../components/CustomButton";
import topimage from "../../assets/topimage.png";
import subscribeImage from "../../assets/subscribeImage.png";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../components/BASE_URL";

// Skeleton loader
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SubscribeSection = () => {
  const { t ,i18n} = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  // 🔹 API state
  const [subscribeData, setSubscribeData] = useState({
    title: "",
    description: "",
  });
  const [loading, setLoading] = useState(true);

useEffect(() => {
  async function loadSubscribe() {
    setLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Home_Subscribe`
      );
      const json = await res.json();

      const section = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home_subscribe"
      );

      if (section?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        setSubscribeData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
        });
      }
    } catch (err) {
      console.error("Error loading subscribe section:", err);
    } finally {
      setLoading(false);
    }
  }

  loadSubscribe();
}, [i18n.language]);


  return (
    <Box
      sx={{
        backgroundColor: "#003149",
        px: isMobile ? 2 : 20,
        py: isMobile ? 6 : 0,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative Images */}
      <img
        src={subscribeImage}
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          top: 160,
          maxWidth: "40%",
        }}
        alt=""
      />
      <img
        src={topimage}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "40%",
          transform: "translateY(-40%)",
        }}
        alt=""
      />

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          py: 10,
        }}
      >
        {/* 🔹 Title from API */}
        <CustomText
          style={{
            ...textStyles.h3,
            color: "#ffffff",
            marginBottom: "1rem",
            fontSize: "47px",
            fontWeight: 700,
            textAlign: "center",
          }}
        >
          {loading ? <Skeleton width={350} height={40} /> : subscribeData.title}
        </CustomText>

        {/* 🔹 Description from API */}
        <CustomText
          style={{
            ...textStyles.body2,
            color: "#D6D6D6",
            marginBottom: "20px",
            fontFamily: "Nunito, sans-serif",
            fontSize: "17px",
            textAlign: "center",
          }}
        >
          {loading ? <Skeleton count={2} width={500} /> : subscribeData.description}
        </CustomText>

        {/* Input + Button */}
        <input
          type="text"
          placeholder={t("subscribe_placeholder")}
          style={{
            marginTop: "20px",
            backgroundColor: "white",
            width: "80%",
            color: "#A8AAAE",
            fontSize: "20px",
            fontWeight: 500,
            fontFamily: "Nunito, sans-serif",
            border: "1px solid #A8AAAE",
            outline: "none",
            padding: "18px 30px 18px 20px",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexWrap: isMobile ? "wrap" : "nowrap",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            mt: 4,
            gap: 2,
          }}
        >
          <CustomButton
            label={t("subscribe_button")}
            onClick={() => {}}
            buttonVariant="primary"
            size="large"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SubscribeSection;

